import { useQuery } from "react-query";

import {
  AI_BUTTON_ANIMATION_COUNT_KEY,
  getLocalStorageItem,
} from "../../helpers/localStorage";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const getAIButtonAnimationCount = (options: APQueryOptions = {}) => {
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["ai-button-animation-count"],
    queryFn: (): number | null => {
      return getLocalStorageItem<number>(AI_BUTTON_ANIMATION_COUNT_KEY) || null;
    },
    enabled: isQueryEnabled(options),
  });
};
